import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PendingActionInterface } from '@app/core/interfaces';
import { Dossier } from '@app/core/interfaces/dossier';
import { BreadcrumbService } from '@app/core/services/breadcrumb.service';
import * as fromLayout from '@app/store/actions/layout.actions';
import * as fromRoot from '@app/store/app.reducer';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as fromMyClaims from '../store';
import * as fromClaims from '../store/actions/claims.actions';
import * as fromClearActions from '../store/actions/clear.actions';

@Component({
    selector: 'ins-damage-claim-container',
    template: ` <ins-damage-claim [claim]="claim$ | async" [actions]="actions$ | async"> </ins-damage-claim>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DamageClaimContainer implements OnInit, OnDestroy {
    public claim$: Observable<Dossier> = this.store$.pipe(
        select(fromMyClaims.getSelectedClaim),
        filter((c) => c !== undefined)
    );
    public actions$: Observable<PendingActionInterface> = this.store$.pipe(
        select(fromMyClaims.getSelectedActions),
        filter((action) => Boolean(action))
    );

    private subscriptions: Subscription = new Subscription();

    constructor(private route: ActivatedRoute, private store$: Store<fromRoot.State>) {}

    ngOnInit(): void {
        const route = this.route.queryParams.subscribe((params) => this.load(params.d));

        const claim = this.claim$.subscribe((_claim: Dossier) => this.setBreadcrumb(_claim));

        this.subscriptions.add(route);
        this.subscriptions.add(claim);
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
        this.store$.dispatch(new fromClearActions.ClearClaimsStore());
    }

    private setBreadcrumb(claim: Dossier): void {
        this.store$.dispatch(
            new fromLayout.SetBreadcrumb([
                BreadcrumbService.HOME,
                BreadcrumbService.MYZONE,
                BreadcrumbService.MYZONE_DAMAGES,
                { title: claim.aard_schadegeval_omschrijving },
            ])
        );
    }

    private load(claimSequenceNumber: number): void {
        this.store$.dispatch(new fromClaims.SetSelected({ dossier_volgnummer: claimSequenceNumber }));
        this.store$.dispatch(new fromClaims.LoadDetail({ dossier_volgnummer: claimSequenceNumber }));
        this.store$.dispatch(new fromClaims.LoadActions({ dossier_volgnummer: claimSequenceNumber }));
    }
}
